import axiosClient from './axiosClient';
import type {
  ComplianceMatrixData,
  ComplianceRequirementData,
  RequirementCreatePayload,
} from '@/types/compliance';

export const complianceApi = {
  getOrCreateMatrix: async (opportunityId: string): Promise<ComplianceMatrixData> => {
    try {
      const response = await axiosClient.get(`/opportunities/${opportunityId}/compliance/matrix`);
      return response.data;
    } catch (err: any) {
      if (err.response?.status === 404) {
        const created = await axiosClient.post(
          `/opportunities/${opportunityId}/compliance/matrix`,
        );
        return created.data;
      }
      throw err;
    }
  },

  getMatrix: async (opportunityId: string): Promise<ComplianceMatrixData | null> => {
    try {
      const response = await axiosClient.get(`/opportunities/${opportunityId}/compliance/matrix`);
      return response.data;
    } catch (err: any) {
      if (err.response?.status === 404) return null;
      throw err;
    }
  },

  createMatrix: async (opportunityId: string): Promise<ComplianceMatrixData> => {
    const response = await axiosClient.post(`/opportunities/${opportunityId}/compliance/matrix`);
    return response.data;
  },

  getRequirements: async (
    opportunityId: string,
    matrixId: string,
  ): Promise<ComplianceRequirementData[]> => {
    const response = await axiosClient.get(
      `/opportunities/${opportunityId}/compliance/matrix/${matrixId}/requirements`,
    );
    return response.data;
  },

  addRequirement: async (
    opportunityId: string,
    matrixId: string,
    data: RequirementCreatePayload,
  ): Promise<ComplianceRequirementData> => {
    const response = await axiosClient.post(
      `/opportunities/${opportunityId}/compliance/matrix/${matrixId}/requirements`,
      data,
    );
    return response.data;
  },

  updateRequirement: async (
    opportunityId: string,
    matrixId: string,
    requirementId: string,
    data: Partial<RequirementCreatePayload>,
  ): Promise<ComplianceRequirementData> => {
    const response = await axiosClient.put(
      `/opportunities/${opportunityId}/compliance/matrix/${matrixId}/requirements/${requirementId}`,
      data,
    );
    return response.data;
  },
};
